import axios from "axios";
import { toast } from "react-toastify";
import { store } from "../index";
import { AES256_GCM_decrypt } from "./Auth/encyptionDecryption";
import { withConsultId } from "./consultScope";

const useMockRoundingNotes =
  process.env.REACT_APP_ROUNDING_NOTES_MOCK === "true";
const useLocalRoundingSeed =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname) &&
  process.env.REACT_APP_ROUNDING_NOTES_SEED !== "false";

const localRoundingPatients = {
  101001: {
    id: 101001,
    patientId: 101001,
    consultId: 501001,
    name: "Maya Srinivasan",
    fname: "Maya",
    lname: "Srinivasan",
    age: 64,
    gender: "Female",
    status: "Active",
    score: "Medium",
    wardName: "ICU",
    bedNumber: "ICU Bed 7",
    hospitalId: 9001,
    hospital: "Local Test Hospital",
    bdProviderId: 70001,
    bdProviderName: "Local Bedside Nurse",
    rdProviderId: 0,
    rdProviderName: "Local Preview",
    remoteProviderType: "Intensivist",
    specializationId: 1,
    order: 1,
    urgent: false,
  },
  101002: {
    id: 101002,
    patientId: 101002,
    consultId: 501002,
    name: "Robert Hayes",
    fname: "Robert",
    lname: "Hayes",
    age: 71,
    gender: "Male",
    status: "Active",
    score: "High",
    wardName: "ICU",
    bedNumber: "ICU Bed 8",
    hospitalId: 9001,
    hospital: "Local Test Hospital",
    bdProviderId: 70001,
    bdProviderName: "Local Bedside Nurse",
    rdProviderId: 0,
    rdProviderName: "Local Preview",
    remoteProviderType: "Intensivist",
    specializationId: 1,
    order: 1,
    urgent: false,
  },
  101003: {
    id: 101003,
    patientId: 101003,
    consultId: 501003,
    name: "Elena Morales",
    fname: "Elena",
    lname: "Morales",
    age: 48,
    gender: "Female",
    status: "Active",
    score: "Low",
    wardName: "ICU",
    bedNumber: "ICU Bed 9",
    hospitalId: 9001,
    hospital: "Local Test Hospital",
    bdProviderId: 70001,
    bdProviderName: "Local Bedside Nurse",
    rdProviderId: 0,
    rdProviderName: "Local Preview",
    remoteProviderType: "Intensivist",
    specializationId: 1,
    order: 1,
    urgent: false,
  },
};

export const getConsultDetail = async (patientId) => {
  if (
    (useMockRoundingNotes || useLocalRoundingSeed) &&
    localRoundingPatients[Number(patientId)]
  ) {
    return {
      status: true,
      patient: localRoundingPatients[Number(patientId)],
    };
  }
  try {
    const response = await axios.post(
      `api/patientEndpoints/v1/getPatientDetailsById`,
      {
        patientId,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateConsultCompletionSummary = async (payload) => {
  try {
    const response = await axios.post(
      `api/patientEndpoints/v1/updateConsultCompletionSummary`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const addCompleteConsultTime = async (data) => {
  try {
    const response = await axios.post(
      `api/patientEndpoints/v1/updateConsultCompletionTime`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReConsultDetail = async (id, patientId) => {
  try {
    const response = await axios.post(
      `api/patientEndpoints/v1/getConsultDetailsById`,
      {
        id,
        patientId,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateAcuities = async (id, token, patientId, score) => {
  try {
    const response = await axios.post(
      `api/patientEndpoints/v1/resetAcuityScore`,
      {
        id,
        token,
        patientId,
        score,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getTeamDetails = async (patientId, consultId, teamName) => {
  try {
    const body = {
      patientId,
      consultId,
      teamName: teamName?.startsWith("Team ")
        ? teamName
        : teamName
        ? `Team ${teamName}`
        : undefined,
    };

    const { data } = await axios.post(
      "api/providerEndpoints/v1/teamDetailsByName",
      body
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getPatientHistory = async (id, patientId) => {
  const state = store.getState();
  const token =
    /*LocalStorageGetValue("token")*/ state?.providerDetailsReducer?.token;
  try {
    const response = await axios.post(
      `api/patientEndpoints/v1/getPatientHistory`,
      {
        id: id,
        patientId: patientId,
        token: token,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getTeams = async (providerId) => {
  try {
    const response = await axios.post(`api/providerEndpoints/v1/teamDetails`, {
      providerId,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getAllTeamDetailsByPatient = async (patientId) => {
  try {
    const { data } = await axios.post(
      `api/providerEndpoints/v1/allTeamDetailsByPatient`,
      { patientId }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const acceptEconsult = async (id, token, patientId, setLoaderFlag) => {
  try {
    let obj = {
      id: id,
      token: token,
      patientId: patientId,
    };
    const response = await axios.post(
      `api/patientEndpoints/v1/acceptInvite`,
      obj
    );
    if (setLoaderFlag) {
      setLoaderFlag(false);
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const acceptHandoffEconsult = async (
  id,
  token,
  patientId,
  setLoaderFlag
) => {
  try {
    let obj = {
      providerId: id,
      patientId: patientId,
    };
    const response = await axios.post(
      `api/providerEndpoints/v1/doRDHandOff`,
      obj
    );
    if (setLoaderFlag) {
      setLoaderFlag(false);
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const decrypt = async (message = "") => {
  const CryptoJS = require("crypto-js");
  const key =
    "E78F5DF838969053C89DB80649AD3A200C93F0108CA2ED7C04499A956FEFD63A";
  const hexStr = message;
  const hexIV = hexStr.substring(0, 32);
  const cipherHexStr = hexStr.substring(128);
  const parsedKey = CryptoJS.enc.Hex.parse(key.toLowerCase());
  const parsedHexIV = CryptoJS.enc.Hex.parse(hexIV);
  const parsedcipherHexStr = CryptoJS.enc.Hex.parse(cipherHexStr);
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: parsedcipherHexStr },
    parsedKey,
    {
      iv: parsedHexIV,
      mode: CryptoJS.mode.CBC,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export async function GetProvidersList(hospitalId, providerId) {
  try {
    const { data } = await axios.post(
      "api/patientEndpoints/v1/GetProvidersForHospital",
      { hospitalId, providerId }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
}
export async function GetWardsWithinHospital(hospitalId) {
  try {
    const { data } = await axios.post(
      "api/hospitalEndpoints/v1/getWardsByHospital",
      { hospitalId }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function GetTransferHospitalList(patientId) {
  try {
    const { data } = await axios.post(
      "api/patientEndpoints/v1/GetTransferHospitalList",
      { patientId }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function BSPHandOffList(providerId) {
  try {
    const { data } = await axios.post(
      "api/providerEndpoints/v1/BspHandOffList",
      { providerId }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function BPHandOver(bspProviderId, summaryNote) {
  try {
    const { data } = await axios.post(
      "api/providerEndpoints/v1/DoBspHandover",
      { bspProviderId, summaryNote }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function RPHandOver(remoteProviderId, summaryNote, patientId) {
  try {
    const { data } = await axios.post(
      "api/providerEndpoints/v1/RDHandOffRequest",
      { remoteProviderId, summaryNote, patientId }
    );
    if (data.status) {
      toast.success(data.errorMessage);
    } else {
      toast.error(data.errorMessage);
    }
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const doRPDirectHandoff = async ({
  summaryNote,
  patientId,
  providerId, // current RD
  newProviderId,
}) => {
  try {
    const response = await axios.post(
      "/api/commonEndpoints/v1/doRPDirectHandoff",
      {
        summaryNote,
        patientId,
        providerId,
        newProviderId,
      }
    );

    if (!response?.data?.status) {
      toast.error(response?.data?.errorMessage || "Handoff failed");
    } else {
      toast.success("Handoff completed successfully!");
    }

    return response.data;
  } catch (error) {
    console.error("Handoff Error:", error);
    toast.error("Something went wrong during handoff");
    return { status: false, errorMessage: "Exception in API" };
  }
};
export const getEligibleMDDOList = async (
  patientId,
  hospitalId,
  rdProviderId
) => {
  try {
    const response = await axios.post(
      "/api/commonEndpoints/v1/getEligibleMDDOList",
      {
        patientId,
        hospitalId,
        rdProviderId,
      }
    );

    if (!response?.data?.status) {
      toast.error(
        response?.data?.errorMessage || "Unable to fetch eligible RPs"
      );
      return { status: false, userList: [] };
    }

    return {
      status: true,
      userList: response.data.userList || [],
    };
  } catch (error) {
    console.error("getEligibleMDDOList Error:", error);
    toast.error("Something went wrong fetching eligible providers");
    return { status: false, userList: [] };
  }
};

export async function doTransferWithinHospital(requestPayload) {
  try {
    const state = store.getState();
    const { id } =
      /*JSON.parse(LocalStorageGetValue("userDetails"))*/ state
        ?.providerDetailsReducer?.provider;
    const { data } = await axios.post(
      "api/patientEndpoints/v1/doTransferWithinHospital",
      { ...requestPayload, bspProviderId: id }
    );
    if (data.status) {
      toast.success(data.errorMessage);
    } else {
      toast.error(data.errorMessage);
    }
    return data;
  } catch (error) {
    console.log(error);
  }
}

export async function patientDischarge(requestPayload) {
  try {
    const res = await axios.post(
      "api/patientEndpoints/v1/dischargePatient",
      requestPayload
    );
    if (res.data.status) {
      toast.success(res.data.errorMessage);
    } else {
      toast.error(res.data.errorMessage);
    }
    return res;
  } catch (error) {
    console.log(error);
  }
}

export async function saveDraft(requestPayload) {
  try {
    // A draft belongs to the consult it was written on, not to the patient.
    const { data } = await axios.post(
      "api/providerEndpoints/v1/saveDraftMessage",
      withConsultId(requestPayload)
    );

    return data;
  } catch (error) {
    console.log(error);
  }
}
export async function getDraft(requestPayload) {
  try {
    const { data } = await axios.post(
      "api/providerEndpoints/v1/getDraftMessages",
      withConsultId(requestPayload)
    );
    return data.chatMessages;
  } catch (error) {}
}

export async function decrypteConsult(requestPayload) {
  try {
    let message;
    await AES256_GCM_decrypt({ data: { encryptedValue: requestPayload } }).then(
      (decryptedValue) => {
        if (typeof decryptedValue === "string" && decryptedValue) {
          message = decryptedValue;
        }
      }
    );
    return message;
  } catch (error) {}
}

export const reconsultPatient = async (patientId) => {
  try {
    const state = store.getState();
    const id =
      /*JSON.parse(LocalStorageGetValue("id"))*/ state?.providerDetailsReducer
        ?.provider?.id;
    const token =
      /*LocalStorageGetValue("token")*/ state?.providerDetailsReducer?.token;
    const response = await axios.post(
      `api/patientEndpoints/v1/inviteProviderBroadCast`,
      {
        patientId,
        id,
        token,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const reconsultOtherPatient = async (patientId, bspProviderId) => {
  try {
    const state = store.getState();
    const id =
      /*JSON.parse(LocalStorageGetValue("id"))*/ state?.providerDetailsReducer
        ?.provider?.id;
    const token =
      /*LocalStorageGetValue("token")*/ state?.providerDetailsReducer?.token;
    const response = await axios.post(
      `api/providerEndpoints/v1/doReconsultOtherPatient`,
      {
        patientId,
        otherBspProviderId: id,
        bspProviderId,
        token,
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export async function DischargedPatient(requestPayload, patientId) {
  try {
    let obj = {
      patientId: patientId,
      dischargeSummary: requestPayload,
    };
    const { data } = await axios.post(
      "api/patientEndpoints/v1/doPatientDischarge",
      obj
    );
    if (!data.status) {
      toast.error(data.errorMessage);
    }
    return data;
  } catch (error) {
    console.log(error);
  }
}
export async function grabPatient(
  patientId,
  summaryNote = null,
  wardName = null
) {
  try {
    const state = store.getState();
    const providerId =
      state?.providerDetailsReducer?.provider?.id ||
      JSON.parse(localStorage.getItem("userDetails"))?.providerId;

    if (!providerId) {
      toast.error("Provider ID missing. Please login again.");
      return { status: false, errorMessage: "Provider ID missing" };
    }

    if (!patientId) {
      toast.error("Patient ID is required.");
      return { status: false, errorMessage: "Patient ID missing" };
    }

    const payload = {
      patientId: patientId,
      providerId: providerId,

      ...(summaryNote && { summaryNote }),

      ...(wardName && { wardName }),
    };

    const response = await axios.post(
      "/api/patientEndpoints/v1/grabPatient",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check if response data is already decrypted
    if (
      response.data &&
      typeof response.data === "object" &&
      "status" in response.data
    ) {
      if (!response.data.status) {
        toast.error(response.data.errorMessage || "Failed to transfer patient");
      } else {
        toast.success("Patient transferred successfully!");
      }

      return response.data;
    }

    // If encrypted, decrypt the response
    const decrypted = await AES256_GCM_decrypt({
      data: { encryptedValue: response.data },
    });

    if (typeof decrypted === "string") {
      const parsed = JSON.parse(decrypted);

      if (!parsed.status) {
        toast.error(parsed.errorMessage || "Failed to transfer patient");
      } else {
        toast.success("Patient transferred successfully!");
      }

      return parsed;
    } else {
      console.error("Invalid decrypted response format:", decrypted);
      toast.error("Invalid response format from server");
      return { status: false, errorMessage: "Invalid response format" };
    }
  } catch (error) {
    console.error("Transfer Patient Error:", error);

    // Handle specific error responses
    if (error.response?.data) {
      const errorData = error.response.data;
      console.log("Error response data:", errorData);

      if (errorData.errorMessage) {
        toast.error(errorData.errorMessage);
        return errorData;
      }
    }

    toast.error("Failed to transfer patient. Please try again.");
    return { status: false, errorMessage: "Network or server error" };
  }
}
export const getEligibleOtherRPUsers = async ({
  patientId,
  teamId,
  consultId,
}) => {
  try {
    const response = await axios.post(
      "api/providerEndpoints/v1/getEligibleOtherRPUsers",
      { patientId, teamId, consultId }
    );

    if (!response?.data?.status) {
      toast.error(
        response?.data?.errorMessage || "Unable to fetch eligible RP users"
      );
      return { status: false, eligibleUsers: [] };
    }

    return {
      status: true,
      eligibleUsers: response.data.eligibleUsers || [],
    };
  } catch (error) {
    console.error("getEligibleOtherRPUsers Error:", error);
    toast.error("Something went wrong fetching eligible RP users");
    return { status: false, eligibleUsers: [] };
  }
};

export const addOtherRPUsersToTeam = async ({
  patientId,
  teamId,
  providerIds,
  consultId,
}) => {
  try {
    const body = {
      patientId: Number(patientId),
      teamId: Number(teamId),
      consultId: Number(consultId),
      providerIds: (providerIds || []).map(Number),
    };

    const { data } = await axios.post(
      "api/providerEndpoints/v1/addOtherRPUsersToTeam",
      body
    );
    if (!data?.status) {
      toast.error(
        data?.errorMessage || "Unable to add other RP Clinicians to team"
      );
      return { status: false };
    }
    toast.success("Other RP clinicians added to team successfully.");
    return { status: true };
  } catch (error) {
    console.error("addOtherRPUsersToTeam Error:", error);
    toast.error("Something went wrong adding RP Clinicians to team");
    return { status: false };
  }
};

export const removeOtherRPUserFromTeam = async ({
  patientId,
  teamId,
  providerId,
  consultId,
}) => {
  try {
    const response = await axios.post(
      "api/providerEndpoints/v1/removeOtherRPUserFromTeam",
      {
        patientId,
        teamId,
        providerId,
        consultId,
      }
    );

    if (!response?.data?.status) {
      toast.error(
        response?.data?.errorMessage ||
          "Unable to remove RP Clinician from team"
      );
      return { status: false };
    }

    toast.success("RP clinician removed from team successfully.");
    return { status: true };
  } catch (error) {
    console.error("removeOtherRPUserFromTeam Error:", error);
    toast.error("Something went wrong removing RP Clinician from team");
    return { status: false };
  }
};

export const getAIPromtAPI = async (passingObject) => {
  try {
    const response = await axios.post(
      "/api/userEndpoints/v1/generateAIENote",
      passingObject
    );

    //return {"value":{}};
    if (response.data.status) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAIPromtAPIPArtOne = async (id) => {
  try {
    const response = await axios.get(
      `/api/userEndpoints/v1/generateAIENote/` + id
    );
    //return {"value":{}};
    if (response.data.status) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export async function feedbackAPIupdates(passingObject) {
  try {
    const { data } = await axios.post(
      "/api/userEndpoints/v1/generateAIAudit",
      passingObject
    );
    if (!data.status) {
      toast.error(data.errorMessage);
    }
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const getBetaAIPromptAPI = async (
  patientId,
  currentDraft = "",
  useRoundingNotes = false
) =>
  getAIPromtAPI({
    patientId,
    mode: "beta",
    // Physician's current in-editor draft — sent as HIGHEST-precedence context so the
    // AI note builds around it and never drops/contradicts what the doctor typed.
    ...(currentDraft && String(currentDraft).trim()
      ? { currentDraft: String(currentDraft) }
      : {}),
    // Opt-in: compile this patient's rounding notes into generation as physician guidance.
    useRoundingNotes: !!useRoundingNotes,
  });

export const getConfigurationByName = async (name) => {
  try {
    const { data } = await axios.get(
      "api/providerEndpoints/v1/getConfigurationName",
      {
        params: { name },
      }
    );
    return data;
  } catch (error) {
    console.log(error);
    return {
      status: false,
      errorMessage: "Unable to load configuration",
    };
  }
};

// cancelToken (optional, axios.CancelToken.source().token) lets callers
// abort the request — e.g. the voice-note path cancels on its send timeout
// so the server stops transcribing. Omitted by eNote dictation (no change).
export const transcribeAIDictation = async (passingObject, cancelToken) => {
  try {
    const response = await axios.post(
      "/api/userEndpoints/v1/transcribeAIDictation",
      passingObject,
      cancelToken ? { cancelToken } : undefined
    );
    return response.data;
  } catch (error) {
    // Log only message/status: the full axios error carries config.data,
    // which for this endpoint is the entire base64 audio payload.
    console.log(
      "transcribeAIDictation failed:",
      error?.response?.status,
      error?.message
    );
    return {
      status: false,
      errorMessage: "Unable to transcribe dictation",
    };
  }
};

//api/userEndpoints/v1/generateAIAudit
